
export const Variant = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Product Variants</h1>
      </div>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-gray-500">Product variants management</p>
      </div>
    </div>
  );
};
